<template>
  <v-content>
    <v-container fluid>
      <Header :title="'Courses'" />
      <Tutor :buttonName="'Book a Tutor'" v-if="has_tutor_products"/>
      <v-row v-for="data in courses" :key="data.course_id">
      <v-col cols="12" >
        <v-card raised>
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-card-title class="headline">
                    {{ data.course_name }}
                    <v-spacer></v-spacer>
                  <v-btn
                    text
                    color
                    :ripple="false"
                    class="included-button"
                  >
                  {{ (Object.keys(currentUser).length !=0 && currentUser.company.account_type == "on-demand" ? data.plan.product_amount : 'Included' )  }} 
                  <v-icon small> {{getCurrency(currentUser,data)}}</v-icon>
                  </v-btn>
                    <v-btn :color="primary_color" style='color:white;' @click='checkCard(data)' v-if='data.is_subscribed == false'>{{ 'Subscribe'| translate }}</v-btn>
                    <v-btn text color :ripple="false" class="included-button" v-if='data.is_subscribed == true'>{{ 'Subscribed'| translate }}</v-btn>
                  </v-card-title>                  
                </v-col>
                <v-col cols="8">
                  <v-card-subtitle class="pt-5" v-html='data.description'></v-card-subtitle>
                  <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <h5>{{ 'Modules' | translate }}</h5>
                      <v-chip-group mandatory column>
                        <v-chip v-for='(moduledata,index) in data.company_modules' :key='index' :to="'/modules/'+moduledata.module_id" >
                          {{ moduledata.title }}
                        </v-chip> 
                      </v-chip-group> 
                    </v-col> 
                  </v-row>
                </v-card-text>
                </v-col>
                <v-col cols="4">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-img
                            :src="storage_url+data.course_image"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            max-width="500"
                            max-height="300"
                          ></v-img>
                        </v-col>
                      </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-card>
      </v-col>


      </v-row>

    </v-container>

    <v-dialog v-if="!loadingdata" v-model="dialog" persistent max-width="1000">
      <v-card >
        <v-card-title class="headline">{{ 'Order Purchase Confirmation' | translate }}</v-card-title>
            <v-card-text>
                <div class="my-4 text-subtitle-1">
                    {{this.course_name}} 
                </div>
                <v-chip-group >
                  <v-chip v-for="(modules, m) in this.course_modules" :key="m">{{modules}}</v-chip>
                </v-chip-group>
            </v-card-text>
            <v-card elevation="0">
              <v-row align="center" justify="space-around">
                <v-col cols="12" sm="7" lg="5">
                    <v-card-title v-if="card_present"> {{'Pay securely using' | translate}} </v-card-title>
                    <v-card-title v-if="!card_present" :class=" no_card_notification ? 'no_card_notification': ''"> {{'Add a Card' | translate}} </v-card-title>
                      <v-row>
                        <v-col v-for="(v, k) in stripeallcards" :key="k" cols="12" sm="6">
                          <v-card v-if="v.is_default" class="mx-auto" max-width="344">
                            <v-card-text>
                              <div>xxxxxxxxxxxx{{v.card_last_four}}</div>

                              <p class="display-1 text--primary">{{v.card_brand}}</p>
                              <div class="text--primary">{{ (Object.keys(currentUser).length !=0 ?  currentUser.name : '') }}</div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col v-if="card_present" cols="12" sm="12">
                          <div > {{ 'Need to change payment method?' | translate }} <v-btn color="primary darken-1" text @click="gotoProfile()">{{ 'Go to profile' | translate }}</v-btn></div>
                        </v-col>
                        <v-col v-if="!card_present" cols="12" sm="12">
                          <div :class=" no_card_notification ? 'no_card_notification': ''"> {{ 'You dont seem to have a card added to your profile' | translate }} 
                          <v-btn color="primary darken-1" text @click="gotoProfile()">{{ 'Go to profile' | translate }}</v-btn>
                          </div>
                        </v-col>
                      </v-row>
                  
                </v-col>
                <v-col cols="12" sm="5">
                  <v-card max-width="800">
                    <v-card-title class="pb-0">{{'Order Summary' | translate}}</v-card-title>
                    <v-container>
                      <v-row justify="space-between">
                        <v-card-subtitle class="title py-1 pl-3">{{ 'Course' | translate }}</v-card-subtitle>
                        <v-card-subtitle class="title py-1 pr-3">{{'Subtotal' | translate}}</v-card-subtitle>
                      </v-row>
                      <v-row justify="space-between">
                        <v-card-subtitle> {{this.course_name}} </v-card-subtitle>
                        <v-card-subtitle>{{ this.product_amount }}{{this.currency}}</v-card-subtitle>
                      </v-row>
                      
                      <v-divider></v-divider>

                      <v-row justify="space-between">
                        <v-card-subtitle>
                          <v-text-field
                            :label="'Coupon Code' | translate"
                            v-model="coupon_id"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                          <div v-if="coupon_valid!=null && !coupon_valid" class="error--text"><v-icon class="theme--dark error--text" small>mdi-alert</v-icon><strong> {{coupon_message|translate}} </strong></div>
                          <div v-if="coupon_valid" class="success--text"><v-icon class="theme--dark success--text" small>mdi-checkbox-marked-circle</v-icon><strong>{{coupon_message|translate}}</strong></div>
                        </v-card-subtitle>
                        <v-card-subtitle>
                          <v-btn
                            rounded
                            small
                            @click="applyCoupon()"
                          >{{'Apply'| translate}}</v-btn>
                          <v-btn
                            rounded
                            small
                            @click="clearCoupon()"
                          >{{'Clear'| translate}}</v-btn>
                        </v-card-subtitle>
                      </v-row>
                      
                      <v-divider></v-divider>

                      <v-row justify="space-between">
                        <v-card-subtitle class="title py-1 pr-3">{{'Total' | translate}}</v-card-subtitle>
                        <v-card-subtitle class="title py-1 pr-3">{{this.product_amount}}{{this.currency}}</v-card-subtitle>
                      </v-row>

                      <v-row justify="center">
                         <v-checkbox v-model="agree_terms" light>
                          <template slot="label">
                            {{'I agree' | translate}} <a @click.stop href="/pages/terms" target="_blank">{{'terms'| translate}}</a>
                          </template>
                        </v-checkbox>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary darken-1" text @click="dialog = false">{{ 'Cancel' | translate }}</v-btn>
                          <v-btn color="green darken-1" text @click="subscribe(course_id)" v-if="agree_terms && (coupon_valid || (coupon_valid==null))">{{ 'Subscribe' | translate }}</v-btn>
                        </v-card-actions>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="course_success_dialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "Thank you for Subscribing"| translate }}</v-card-title>
        <v-card-subtitle>{{ "You can find subscribed courses in your Dashboard"| translate }}</v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text to="/dashboard">{{ 'Go to dashboard' | translate }}</v-btn>
          <v-btn color="primary darken-1" text @click="course_success_dialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

import {
  FETCH_COURSES,
  COURSE_SUBSCRIBE,
  RESET_STATE,
  VALIDATE_COUPON,
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
export default {
  name: "ModulesDetails",
   async beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_COURSES, '').then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)
      }
    });

    store.commit(SET_ROUTER_ENTER, false)
    return next();
  },
  computed: {
    ...mapGetters([
      "courses",
      "stripesecretkey",
      "currentUser",
      "loadingdata",
      'routerenter',
      "languages",
      "stripeallcards"
    ])
  },
  components: {
    Header: () => import("@/components/header/Header"),
    Tutor: () => import("@/components/modal/Tutor")
  }, 
  mounted(){ 
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
     if(company_meta.hasOwnProperty('has_tutor_products')){
      this.has_tutor_products = (company_meta.has_tutor_products==='true')
    }
  },
  created() {
    this.storage_url  = process.env.VUE_APP_STORAGE_URL
    let companymeta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = companymeta.primary_color;
    this.courses.forEach((item)=> {
        let product_amount = ((item.plan.product_amount)?(item.plan.product_amount):'0')
        let coupon_amount = ((item.plan.coupon_amount !== null)?(item.plan.coupon_amount):null)
        this.courseData.push({'course_id':item.course_id,'product_amount':product_amount, 'coupon_amount': coupon_amount})
    })
  },
  data: function() {
    return {
      courseData:[],
      course_id: null,
      course_name: null,
      course_modules: [],
      product_amount: null,
      default_product_amount: null,
      currency:null,
      agree_terms: false,
      dialog: false,
      storage_url: '',
      primary_color:'',
      isLoading: false,
      coupon_id: null,
      card_present:false,
      coupon_amount: null,
      coupon_message:null,
      coupon_valid: null,
      course_success_dialog: false,
      no_card_notification:false,
      all_valid: false,
      has_tutor_products:false,
      };
  },
  methods: {
    getCurrency(currentUser,data){
      if(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' && data.plan.product_amount !== null && data.plan.currency == 'eur'){
        this.currency = "€"
        return 'mdi-currency-eur'
      }
      else if(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' && data.plan.product_amount !== null){
        this.currency = "$"
        return '$'
      }
    },
    checkCard(data) {
      if (this.currentUser.company.account_type == "on-demand") {
      this.coupon_id = null //Clear any previous coupon codes
      this.coupon_valid = null
          this.dialog = true;
          this.course_id = data.course_id
          this.course_name = data.course_name
          this.course_modules.length = 0
          data.company_modules.forEach(element => {
            this.course_modules.push(element.title)
            this.course_modules.push(element.language.lang_name)
          });

          let index = this.courseData.map(function(x) {return x.course_id; }).indexOf(data.course_id)
          this.default_product_amount= this.courseData[index]['product_amount']
          this.product_amount= this.courseData[index]['product_amount']
          this.coupon_amount= this.courseData[index]['coupon_amount']
      if (this.stripeallcards.length !== 0) {
        this.card_present = true;
      }
        
      } else if (this.currentUser.company.account_type == "full-version") {
        this.isLoading = true
        let params={
          id:data.course_id,
        }
        this.$store.dispatch(COURSE_SUBSCRIBE, params).then(resp => {
          if (resp !=undefined && resp.success) {
              this.$store.dispatch(FETCH_COURSES, '').then(resp => {
                if (resp.success) {
                  store.commit(SET_LOADING, false);
                  this.isLoading = false
                }
              }); 
          }
          else{
            store.commit(SET_LOADING, false);
            this.isLoading = false
          }
        });
      }
    },
    gottoCourse(){
      this.$router.push("/courses");
    },
    async subscribe(id) {
      if (this.currentUser.company.account_type == "on-demand") {
        this.dialog = true;

        //first we check if any coupon is present and if present is valid
        if(this.coupon_id){
          await this.applyCoupon()
        }
      //You can subscribe if
      // coupon is valid and product amount is zero
      // coupon is valid and product_amount is not zero and card is present
      // no coupon and card is present
        var params ={
            id:id,
        }
        if((this.coupon_valid) && (this.product_amount == 0)){
          params['coupon_code']= this.coupon_id
          this.all_valid = true
        } else if(this.coupon_valid && (this.product_amount != 0) && !this.card_present){
          this.no_card_notification = true
          this.all_valid = false
        } 
        else if(!this.coupon_valid && this.coupon_id){
              this.coupon_valid = false
              this.all_valid = false
        }
        else if( (this.product_amount != 0) && !this.card_present){
          this.no_card_notification = true
          this.all_valid = false
        }
        else{
          //check when card is present logic
          this.all_valid = true
        }  

        if(this.all_valid){
          this.dialog = false;
          this.isLoading = true
          await this.$store.dispatch(COURSE_SUBSCRIBE, params).then(resp => {
            if (resp.success) {
                this.dialog = false;
                this.$store.dispatch(FETCH_COURSES, '').then(resp => {
                  if (resp.success) {
                    this.coupon_valid = false
                    this.coupon_id = null
                    this.agree_terms = false
                    this.isLoading = false
                    store.commit(SET_LOADING, false);
                    this.course_success_dialog = true;
                  }
                  else{
                    store.commit(SET_LOADING, false);
                    this.isLoading = false
                  }
                });              
            }
          });
        }
        else{
              this.product_amount = this.default_product_amount
              this.isLoading = false
        }
      
      }
      else {
        this.isLoading = true
        let params={
          id:id,
        }
        this.$store.dispatch(COURSE_SUBSCRIBE, params).then(resp => {
          if (resp != undefined && resp.success) {
              this.$store.dispatch(FETCH_COURSES, '').then(resp => {
                if (resp.success) {
                  this.isLoading = false
                  store.commit(SET_LOADING, false);
                }
              }); 
          }
          else{
            this.isLoading = false
            store.commit(SET_LOADING, false);
          }
        });
      }
    },
    gotoProfile(){
      this.dialog = false;
      this.$router.push("/profile");
    },
    clearCoupon(){
      this.coupon_id = null;
      this.coupon_valid = null;
      this.product_amount = this.default_product_amount;
    },
    async applyCoupon(){
      store.commit(SET_LOADING, false)
      var params = 'item_id='+this.course_id;
      if(this.coupon_id){
        params = 'item_id='+this.course_id+'&coupon_code='+this.coupon_id;
      }

      await this.$store.dispatch(VALIDATE_COUPON,params).then(resp => {
          if (resp !=undefined && resp.success) {
              this.coupon_valid = true
              this.product_amount = this.coupon_amount
              this.coupon_message = resp.message
              this.isLoading = false
          }
          else{
            this.product_amount = this.default_product_amount
            this.coupon_valid = false
            this.coupon_message = resp.response.data.message
            this.isLoading = false
          }
        });
    }
  }
};
</script>
<style scoped>
.included-button{
  cursor: default !important;
}
.included-button::before {
  background-color: transparent !important;
}
.subscribed-button{
  cursor: default !important;
}
.subscribed-button::before {
  background-color: transparent !important;
}
.no_card_notification{
  color: red;
}
</style>